import React from 'react';

import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import RequestDemoLinkBlock from '@app/components/UI/components/RequestDemoLinkBlock';

import '@app/scss/pages/aboutUs.scss';

const AboutUs: React.FC = () => {
	const [isMobile, setIsMobile] = React.useState(false);
	const [oldImage, setOldImage] = React.useState<boolean>(false);
	React.useEffect(() => {
		(window as any).toggleOldImage = () => setOldImage(prev => !prev);
		const resize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		resize();
		window.addEventListener('resize', resize);

		return () => {
			(window as any).toggleOldImage = undefined;
			window.removeEventListener('resize', resize);
		};
	}, []);
	return (
		<div className="about-us">
			<div className="top-banner" id="home">
				<div className="image-block">
					<picture>
						<source media="(max-width: 600px)" srcSet="/images/home-image-1.png"/>
						<source media="(max-width: 768px)" srcSet="/images/home-image-1.png"/>
						<source media="(min-width: 769px)" srcSet="/images/home-image-1.png"/>
						<img className="top-banner__image" alt="banner" srcSet="/images/home-image-1.png"/>
					</picture>
					<div className="banner-text">
						<h1>
							About Us
						</h1>
						<div className="is-relative">
							<div className="skew-block-right">
								<div className="skew-block blue-border skew-padding-s white-block">
									<p className="text-primary text-primary-big" style={{fontWeight: 500, fontSize: 20}}>
										Executive Tags is more than just a technology-driven portal. Our innovative online platform was
										specifically crafted to significantly reduce the extensive phone calls and confusion typically
										associated with DMV interactions. By seamlessly providing clear information on fees, taxes, and
										documentation requirements, our platform saves valuable time and resources.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="padding-top-m about-first">
				<div className="skew-padding-text" style={{transform: 'translateY(25%)'}}>
					<div className="skew-block-left">
						<div className="blue-dark-block skew-block skew-padding-s" style={{maxWidth: '88vw'}}>
							<h2 className="margin-0">
								Who we are
							</h2>
						</div>
					</div>
				</div>
				<div className="about-us-block-1">
					<div className="skew-block blue-dark-border">
						<ImageLazy
							alt="about us"
							className="about-img-1"
							src={`/images/about-1${isMobile ? '-mobile' : oldImage ? '' : '_2'}.png`}
						/>
						<div className="content-block" style={{paddingLeft: 260}}>
							<div className="col-2-block">
								<p style={{maxWidth: 417}}>
									Established in 2006 and proudly headquartered in West Palm Beach, Florida, Executive Tags specializes in
									streamlining vehicle titling, registration, and compliance services for automotive dealerships and local
									individuals nationwide. We understand the complexity and stress often associated with DMV processes—our
									mission is to simplify these procedures, delivering clear, efficient, and worry-free experiences for our
									clients.
									<br/>
									<br/>
									Our longstanding direct relationships with DMV offices across all 50 states further enhance our
									ability to offer swift, accurate, and dependable services. Backed by real-time tracking technology, precise
									fee calculations, and proactive client support, our platform and dedicated team deliver unmatched accuracy,
									efficiency, and transparency.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="padding-top-m about-second">
				<div className="skew-padding-text">
					<div className="skew-block-right" style={{ transform: 'translateX(30vw)' }}>
						<div className="blue-dark-block skew-block skew-padding-s" style={{ paddingLeft: '20vw' }}>
							<h2 className="margin-0">
								What we do
							</h2>
						</div>
					</div>
				</div>
				<div className="about-us-block-2">
					<div className="skew-block blue-dark-border transform-top">
						<ImageLazy
							alt="about us"
							className="about-img-2 transform-top"
							src={`/images/about-2${isMobile ? '-mobile' : oldImage ? '' : '_2'}.png`}
						/>
						<div className="content-block" style={{paddingLeft: 260}}>
							<div className="col-2-block">
								<p className="text-end" style={{maxWidth: 568, marginLeft: 'auto' }}>
									What truly sets Executive Tags apart is our dedicated, hands-on processing center staffed with seasoned DMV
									experts. These professionals shoulder the administrative burden typically placed on dealership title clerks,
									freeing up your team to focus on local, in-state tasks. We manage every step of your transaction meticulously and
									proactively, ensuring clear and continuous communication with both you and your customers.
									<br/>
									<br/>
									Whether you’re a Sales Manager, Finance Manager, Title Clerk, Office Manager, or Controller, Executive Tags
									empowers your dealership to perform at its best saving you time, reducing errors, and significantly boosting
									customer satisfaction.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<RequestDemoLinkBlock
				content={<>
					<p style={{fontSize: 27}}>
						Choose Executive Tags for your vehicle registration and titling needs—experience clarity, convenience, and
						confidence with every transaction.
					</p>
				</>}
			/>
		</div>
	);
};

export default AboutUs;
